<script setup lang="ts">
import { computed, ref } from 'vue';

const $props = defineProps<{
  modelValue?: boolean;
  toggleAccept?: boolean;
}>();

const $slots = defineSlots<{
  activator: (props: { toggleDialog: () => void }) => any;
}>();

const $emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'accept'): void;
}>();

const internalModel = ref(false);
const tab = ref('sozlesme');

const dialogModel = computed({
  get: () => (!$slots.activator ? $props.modelValue : internalModel.value),
  set: (val: boolean) => {
    if (!$slots.activator) {
      $emit('update:modelValue', val);
    } else {
      internalModel.value = val;
    }
  },
});

function toggleDialog() {
  dialogModel.value = !dialogModel.value;
}

function accept() {
  $emit('accept');
  if ($props.toggleAccept) {
    toggleDialog();
  }
}
</script>

<template>
  <span class="terms-and-agreement-dialog--activator">
    <slot name="activator" :toggleDialog="toggleDialog" />
  </span>

  <q-dialog v-model="dialogModel" persistent>
    <q-card style="width: 700px; max-width: 90vw">
      <q-card-section>
        <h1 class="text-h6">KVKK ve Açık Rıza</h1>
      </q-card-section>

      <q-separator />

      <q-card-section>
        <div class="scroll-area">
          <h1 class="text-h6">Kişisel Verilerin Korunması Bilgilendirme Metni ve Açık Rıza</h1>

          <p>6698 sayılı KVKK kapsamında kişisel verilerinizin işlenmesi hakkında bilgilendirmedir.</p>

          <h2>Verilerin Yurt Dışına Aktarımı ve İşlenmesi</h2>
          <p>
            Hazel Jewellery olarak, web sitemizin veri güvenliğini en üst seviyede tutmak, kesintisiz ve yüksek performanslı hizmet sunmak amacıyla veri tabanı ve sunucu
            hizmetlerini
            <strong>Hetzner Online GmbH (Almanya)</strong> bünyesinde barındırmaktayız.
          </p>

          <!-- === YENİ AÇIK RIZA BÖLÜMÜ === -->
          <q-banner dense class="bg-primary text-white q-mt-md q-mb-lg">
            <div class="text-center text-h6">Kişisel verilerimin yurt dışında bulunan sunucularda işlenmesine ve saklanmasına açık rıza veriyorum.</div>
          </q-banner>

          <h3>Neden Hetzner Online GmbH?</h3>
          <p>
            Hetzner, Avrupa’nın önde gelen ve dünya çapında tanınan hosting sağlayıcılarından biridir. Almanya merkezli bu firma,
            <strong>yüksek kaliteli altyapısı</strong>, <strong>üstün güvenlik standartları</strong> ve <strong>küresel güvenilirliği</strong> ile tercih edilmektedir.
          </p>
          <ul>
            <li>GDPR (Avrupa Veri Koruma Yönetmeliği) ile tam uyumlu, sertifikalı veri merkezleri</li>
            <li>ISO 27001, BSI C5 ve diğer uluslararası güvenlik sertifikaları</li>
            <li>24/7 fiziksel ve siber güvenlik izleme, DDoS koruması, yedekli güç ve soğutma sistemleri</li>
            <li>Yüksek performans, %99,9+ uptime garantisi ve son teknoloji donanım altyapısı</li>
            <li>AB içinde (Almanya) barındırma sayesinde verileriniz hiçbir üçüncü ülkeye aktarılmamaktadır</li>
          </ul>
          <p>
            Bu sayede verileriniz hem <strong>güvenli</strong> hem de <strong>hızlı ve kesintisiz</strong> bir şekilde saklanıp işlenebilmektedir. Hetzner ile aramızda
            imzalanmış olan Veri İşleme Anlaşması (DPA) kapsamında tüm işlemler KVKK ve GDPR kurallarına uygun olarak yürütülmektedir.
          </p>

          <h2>Haklarınız</h2>
          <p>
            KVKK’nın 11. maddesi kapsamında verilerinizin işlenip işlenmediğini öğrenme, düzeltme, silme ve yurt dışı aktarımına ilişkin haklarınız saklıdır. İletişim
            sayfamızdan veya e-posta yoluyla başvurabilirsiniz.
          </p>

          <q-banner dense class="bg-blue-1 text-caption q-mt-md">
            <q-icon name="info" color="primary" />
            “Okudum, Kabul Ediyorum” butonuna basarak yukarıdaki <strong>açık rıza</strong> beyanınızı özgür iradenizle vermiş sayılırsınız. Bu rızanızı her zaman geri
            alabilirsiniz.
          </q-banner>
        </div>
      </q-card-section>

      <q-separator />

      <q-card-actions align="right" class="q-pa-md">
        <q-btn flat label="Reddet" color="grey" @click="toggleDialog" />
        <q-btn unelevated label="Okudum, Kabul Ediyorum" color="primary" @click="accept" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<style scoped>
.scroll-area {
  max-height: 50vh;
  overflow-y: auto;
  padding-right: 10px;
}
h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
h2,
h3 {
  font-size: 16px;
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 5px;
  color: #333;
}
p,
ul {
  font-size: 14px;
  line-height: 1.5;
  color: #555;
}
ul {
  padding-left: 20px;
}
</style>
